import React from "react";

interface ServiceOutcomesProps {
  title?: string;
  description?: string;
  outcomes: string[];
}

const ServiceOutcomes: React.FC<ServiceOutcomesProps> = ({
  title = "Services outcome",
  description = "We create powerful digital platforms that combine beautiful design with robust functionality, delivering exceptional user experiences and measurable business results.",
  outcomes,
}) => {
  return (
    <div className="services-outcome-wrap mt-60 mb-40">
      <h2 className="details-content-title text-center mb-20" style={{ color: "#fff" }}>{title}</h2>
      <p className="text-center mb-50" style={{ 
        color: "rgba(255,255,255,0.85)", 
        maxWidth: "800px", 
        margin: "0 auto 50px",
        fontSize: "16px",
        lineHeight: "1.7"
      }}>{description}</p>

      <div
        style={{
          padding: "40px",
          borderRadius: "18px",
          background: "rgba(255,255,255,0.06)",
          border: "1px solid rgba(255,255,255,0.12)",
          backdropFilter: "blur(10px)",
        }}
      >
        <ul className="list-unstyled" style={{ margin: 0 }}>
          {outcomes.map((item, i) => (
            <li
              key={i}
              className="wow fadeInUp"
              data-wow-delay={`${i * 80}ms`}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                padding: "18px 24px",
                marginBottom: i < outcomes.length - 1 ? "12px" : "0",
                borderRadius: "12px",
                background: "rgba(255,255,255,0.03)",
                border: "1px solid rgba(255,255,255,0.08)",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "rgba(255,140,0,0.1)";
                e.currentTarget.style.borderColor = "rgba(255,140,0,0.2)";
                e.currentTarget.style.transform = "translateX(10px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "rgba(255,255,255,0.03)";
                e.currentTarget.style.borderColor = "rgba(255,255,255,0.08)";
                e.currentTarget.style.transform = "translateX(0)";
              }}
            >
              <span
                style={{
                  minWidth: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.2"
                    d="M24 12C24 13.024 22.742 13.868 22.49 14.812C22.23 15.788 22.888 17.148 22.394 18.002C21.892 18.87 20.382 18.974 19.678 19.678C18.974 20.382 18.87 21.892 18.002 22.394C17.148 22.888 15.788 22.23 14.812 22.49C13.868 22.742 13.024 24 12 24C10.976 24 10.132 22.742 9.188 22.49C8.212 22.23 6.852 22.888 5.998 22.394C5.13 21.892 5.026 20.382 4.322 19.678C3.618 18.974 2.108 18.87 1.606 18.002C1.112 17.148 1.77 15.788 1.51 14.812C1.258 13.868 0 13.024 0 12C0 10.976 1.258 10.132 1.51 9.188C1.77 8.212 1.112 6.852 1.606 5.998C2.108 5.13 3.618 5.026 4.322 4.322C5.026 3.618 5.13 2.108 5.998 1.606C6.852 1.112 8.212 1.77 9.188 1.51C10.132 1.258 10.976 0 12 0C13.024 0 13.868 1.258 14.812 1.51C15.788 1.77 17.148 1.112 18.002 1.606C18.87 2.108 18.974 3.618 19.678 4.322C20.382 5.026 21.892 5.13 22.394 5.998C22.888 6.852 22.23 8.212 22.49 9.188C22.742 10.132 24 10.976 24 12Z"
                    fill="#ff8c00ff"
                  />
                  <path
                    d="M15.5559 9.14076L11.3992 13.178L9.24437 11.0869C8.77664 10.6326 8.01773 10.6326 7.55001 11.0869C7.08229 11.5412 7.08229 12.2783 7.55001 12.7326L10.5729 15.6686C11.0279 16.1105 11.7668 16.1105 12.2218 15.6686L17.2484 10.7864C17.7162 10.3321 17.7162 9.59504 17.2484 9.14076C16.7807 8.68648 16.0236 8.68648 15.5559 9.14076Z"
                    fill="#ff8c00ff"
                  />
                </svg>
              </span>
              <span
                style={{
                  color: "rgba(255,255,255,0.95)",
                  fontSize: "16px",
                  fontWeight: "500",
                  lineHeight: "1.6",
                }}
              >
                {item}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ServiceOutcomes;
